module.exports = __webpack_public_path__ + "static/media/port-charlotte-bg.1d086781.jpg";